module.exports = __webpack_public_path__ + "img/whats-app.c8745916.svg";